import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { Link } from "react-router-dom";

interface ComingSoonProps {
  title: string;
  description: string;
}

export default function ComingSoon({ title, description }: ComingSoonProps) {
  return (
    <div className="min-h-screen bg-[#FAFAF8] font-['Noto_Sans_KR']">
      <Navbar />
      <main className="pt-24 pb-16 px-4 md:px-6">
        <div className="max-w-[600px] mx-auto text-center">
          <div className="w-20 h-20 mx-auto mb-6 rounded-2xl bg-[#C4956A]/10 flex items-center justify-center">
            <i className="ri-tools-line text-3xl text-[#C4956A]"></i>
          </div>
          <h1 className="text-2xl md:text-3xl font-bold text-[#1C1917] mb-4">
            {title}
          </h1>
          <p className="text-sm text-[#8C8780] leading-relaxed mb-8">
            {description}
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-[#1C1917] text-white text-sm font-medium rounded-full hover:bg-[#C4956A] transition-all"
          >
            <i className="ri-arrow-left-line"></i>
            메인으로 돌아가기
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}